import Vue from 'vue'
import Router from 'vue-router'

import PrefixBanner from './views/PrefixBanner.vue'
import Index from './views/Index.vue'
import ArticleList from './views/ArticleList.vue'
import ArticleDetail from './views/ArticleDetail.vue'
import ApplyForEnter from './views/ApplyForEnter.vue'
import Location from './views/Location.vue'
import SearchPage from './views/SearchPage.vue'
import ParkHonor from './views/ParkHonor.vue'
import PatentSearch from './views/PatentSearch/PatentSearch.vue'
import Introduction from './views/PatentSearch/Introduction.vue'
import PatentDetail from './views/PatentSearch/PatentDetail.vue'
import AllPatent from './views/PatentSearch/AllPatent.vue'
Vue.use(Router)

export default new Router({
  mode:'history',
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },
  routes: [
    {
      path: '/',
      name: 'PrefixBanner',
      component: PrefixBanner
    },{
      path: '/index',
      name: 'Index',
      component: Index
    },{
      path: '/articleList',
      name: 'ArticleListPage',
      component: ArticleList
    },{
      path: '/articleDetail',
      name: 'ArticleDetailPage',
      component: ArticleDetail
    },{
      path: '/location',
      name: 'Location',
      component: Location
    },{
      path: '/park_honor',
      name: 'ParkHonor',
      component: ParkHonor
    },{
      path: '/search',
      name: 'Search',
      component: SearchPage
    },{
      path: '/applyForEnter',
      name: 'ApplyForEnter',
      component: ApplyForEnter
    },{
      //院校机构
      path: '/patentSearch',
      name: 'PatentSearch',
      component: PatentSearch
    }, {
      //院校介绍
      path: '/patentSearch/introduction',
      name: 'Introduction',
      component: Introduction
    }, {
      //专利详情
      path: '/patentSearch/patentDetail',
      name: 'PatentDetail',
      component: PatentDetail
    }, {
      //所有专利
      path: '/patentSearch/allPatent',
      name: 'AllPatent',
      component: AllPatent
    }
  ]
})